import {
    // FORMS_SIGN_AS_SUPERVISOR,
} from './permissions';

// These permissions will be checked for truthiness even if user is admin or owner of project.
export const PROJECT_EXPLICIT_PERMISSIONS = [
    // FORMS_SIGN_AS_SUPERVISOR,
];